import { Navigate } from "react-router-dom";
import { useAuth } from "./authContext";

const ProtectedRoute = ({ code, children }) => {
    const { permissions } = useAuth();

    if (!permissions) return null;

    if (permissions.includes(code) || permissions.includes("fullAccess")) {
        return children;
    }

    return code ? <Navigate to="/403" replace /> : <Navigate to="/dashboard" replace />;
};

export default ProtectedRoute;